import { ActionBar, ButtonVariant } from '@dreryk/react-components';
import { useDraftRemoveByTokenCqrsCommand } from '@dreryk/react-draft';

import { getReferralDraftToken } from '../../referral.draft';
import { referralTranslationKeys } from '../../translations';
import { ReferralToSpecialistFormController } from '../ReferralToSpecialistForm/ReferralToSpecialistForm.types';

import { useReferralToSpecialistConfirmAndPrintCommand } from './ReferralToSpecialistSendAction.hooks';

type ReferralToSpecialistSendActionProps = {
   readonly handleSubmit: ReferralToSpecialistFormController['handleSubmit'];
   readonly visitId: number;
   readonly onSuccess: VoidFunction;
};

export const ReferralToSpecialistSendAction = (props: ReferralToSpecialistSendActionProps): JSX.Element => {
   const { executeAsync: removeDraft } = useDraftRemoveByTokenCqrsCommand();
   const { executeAsync: sendReferralToSpecialist } = useReferralToSpecialistConfirmAndPrintCommand(
      props.visitId,
      async () => {
         props.onSuccess();
         await removeDraft({ token: getReferralDraftToken('referralToSpecialist', props.visitId) });
      }
   );
   return (
      <ActionBar.PrimaryButton
         variant={ButtonVariant.PRIMARY}
         onClick={props.handleSubmit(sendReferralToSpecialist)}
         label={referralTranslationKeys.actionBar.confirmAndPrint}
         testId={'confirmAndPrint'}
         blockingOperation
      />
   );
};
